import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const ProductAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default ProductAddButton;